__webpack_require__.p = "/gold-fever/";